module.exports = __webpack_public_path__ + "static/media/tsu.ebdceee5.png";